module.exports = __webpack_public_path__ + "media/footer/youtube-ee995466.svg";